export default __webpack_public_path__ + "static/landing-collab-top-image-b-49d3e0f9b6bc67d6f9b0ec69bead40b3.png";